import script from "./checkItem.vue?vue&type=script&setup=true&lang=js"
export * from "./checkItem.vue?vue&type=script&setup=true&lang=js"

import "./checkItem.vue?vue&type=style&index=0&id=c748ace2&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c748ace2"]])

export default __exports__